module.exports = __webpack_public_path__ + "img/looks-good-pika.60cf06d9.gif";